export default function AchievementSticker({ text, variant = 'fill', className = '', style }) {
  return (
    <span className={`motif-sticker motif-sticker--${variant} ${className}`.trim()} style={style}>
      [ {text} ]
    </span>
  );
}
